import { jsx as _jsx } from "react/jsx-runtime";
import { ViewTypeName } from "@air/api/types";
import { Check as CheckIcon, Grid as GridIcon, Kanban as KanbanIcon, List as ListIcon } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { DropdownMenuWithActionSheet } from "~/components/Menus/DropdownMenuWithActionSheet";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
const viewTypeViewMap = {
    [ViewTypeName.gallery]: {
        icon: GridIcon,
        label: "Gallery"
    },
    [ViewTypeName.table]: {
        icon: ListIcon,
        label: "Table"
    },
    [ViewTypeName.kanban]: {
        icon: KanbanIcon,
        label: "Kanban"
    }
};
export const ViewTypeToggleMenuComponent = (param)=>{
    let { availableViewTypeNames, onChange, currentViewTypeName, dataTestId } = param;
    const { searchImprovements } = useTemporaryFeatureFlags();
    const { icon: currentIcon, label: currentLabel } = viewTypeViewMap[currentViewTypeName];
    return /*#__PURE__*/ _jsx(DropdownMenuWithActionSheet, {
        align: "end",
        options: availableViewTypeNames.map((viewTypeName)=>{
            const { icon: OptionIcon, label } = viewTypeViewMap[viewTypeName];
            return {
                id: viewTypeName,
                label: label,
                onSelect: ()=>onChange(viewTypeName),
                prefix: /*#__PURE__*/ _jsx(OptionIcon, {
                    className: "size-4"
                }),
                suffix: viewTypeName === currentViewTypeName ? /*#__PURE__*/ _jsx(CheckIcon, {
                    className: "size-4"
                }) : null,
                type: "item"
            };
        }),
        size: "small",
        trigger: /*#__PURE__*/ _jsx(IconButton, {
            appearance: "ghost",
            color: "grey",
            label: currentLabel,
            icon: currentIcon,
            size: searchImprovements ? "small" : "medium",
            "data-testid": dataTestId
        }),
        title: "View Type"
    });
};
